import * as React from "react";

function SvgFilters(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="1em" height="1em" {...props}><path className="filters_svg__st0" d="M41.4 10.2C39.6 4.8 34.5 1 28.5 1s-11.1 3.9-12.9 9.2H.1v8.7h15.5c1.8 5.4 6.9 9.2 12.9 9.2s11.1-3.9 12.9-9.2h58.8v-8.7H41.4zM72.1 36.4c-6 0-11.1 3.9-12.9 9.2H.1v8.7h59.1c1.8 5.4 6.9 9.2 12.9 9.2s11.1-3.9 12.9-9.2h15.2v-8.7H85c-1.8-5.3-6.9-9.2-12.9-9.2zM50.1 71.8c-6 0-11.1 3.9-12.9 9.2H.1v8.7h37.1c1.8 5.4 6.9 9.2 12.9 9.2S61.2 95 63 89.7h37.1V81H63c-1.8-5.3-6.9-9.2-12.9-9.2z" /></svg>;
}

export default SvgFilters;